const API_VERSION = "v1.3.3";
const API_URI = await getApi();

async function getApi() {
	const apiHost = window.location.hostname === "localhost" ? "http://localhost:4500" : "https://api.agm.wiktorgolicz.pl";
	if (API_VERSION === "dev") {
		if (window.location.hostname !== "localhost")
			console.warn("The dev API version is shouldn't be used in production!");
		return `${apiHost}/dev/api.php`;
	}

	const response = await fetch(`${apiHost}/list.php`);
	const { availableVersions } = await response.json();

	const [major, minor, patch] = API_VERSION.substring(1)
		.split(".")
		.map(Number);

	const latestVersion = availableVersions.toReversed().find(version => {
		const [majorVersion, minorVersion, patchVersion] = version
			.substring(1)
			.split(".")
			.map(Number);
		return majorVersion === major && minorVersion === minor && patchVersion >= patch;
	});

	if (!availableVersions.includes(API_VERSION) || !latestVersion) {
		console.log("No matching API version found");
	}

	return `${apiHost}/${latestVersion ?? API_VERSION}/api.php`;
}

export default API_URI;
